<template lang="html">
  <section class="productions">
    <article
      class="productions__hero"
      :style="{ backgroundImage: `url(${pageCopy.heroImage})` }"
    >
      <div class="productions__textBox">
        <h1 class="title">
          <span>Green <em>Produc&shy;tions</em></span>
        </h1>
        <h2 class="productions__subtitle monitor monitorHide">
          {{pageCopy.heroSubtitle}}
        </h2>
        <p class="productions__text monitor monitorHide" v-for="bit in pageCopy.heroText.split('\n')">
          {{bit}}
        </p>
      </div>
    </article>
    <article class="productions__body">
      <h2 class="productions__subtitle monitor monitorHide">
        {{pageCopy.contentTitle}}
      </h2>
      <p class="productions__text monitor monitorHide">
        {{pageCopy.contentSubtitle}}
      </p>
      <div class="productions__listContainer">
        <ul class="productions__list">
          <li
            class="productions__listItem monitor monitorHide"
            v-for="item in pageCopy.contentList"
          >
            {{ item }}
          </li>
        </ul>
        <figure class="monitor monitorHide">
          <img :src="pageCopy.contentListImage" alt="" />
        </figure>
      </div>
      <figure class="monitor monitorHide" style="margin-bottom: 40px">
        <img :src="pageCopy.contentImage" alt="" />
      </figure>
      <p class="productions__text monitor monitorHide" v-for="bit in pageCopy.contentText.split('\n')">
        {{bit}}
      </p>
    </article>
  </section>
</template>

<script>
import anime from "animejs";
import scrollMonitor from "scrollmonitor";

export default {
  name: "Productions",
  components: {},
  mounted() {
    setTimeout(() => {
      var elementList = document.querySelectorAll(".monitor");
      elementList.forEach(element => {
        var elementWatcher = scrollMonitor.create(element);
        elementWatcher.enterViewport(function() {
          element.classList.remove("monitorHide");
        });
        elementWatcher.exitViewport(function() {
          element.classList.add("monitorHide");
        });
      });
    }, 1000);
  },
  computed: {
    pageCopy() {
      return this.$store.state.productionsCopy;
    }
  }
};
</script>

<style lang="scss">
@import "../styles/config.scss";
.productions {
  /* max-width: 1240px; */
  width: 100%;
  margin: 0 auto;
  padding: 0;
  .monitor {
    opacity: 1;
    transition: all 0.5s ease-out 0.3s;
  }
  .monitorHide {
    opacity: 0 !important;
    transform: translateY(80px) !important;
  }
  &__subtitle {
    font-family: CamptonBold;
    font-size: 27px;
    font-weight: bold;
    color: var(--Neu01);
    margin-bottom: 40px;
  }
  &__text {
    font-family: CamptonBook;
    font-size: 20px;
    line-height: 1.35;
    color: var(--Neu01);
    margin-bottom: 20px;
  }
  &__hero {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  &__textBox {
    width: 830px;
    padding: 0 30px;
    h1 {
      margin-left: 0;
      margin-bottom: 40px;
    }
    em {
      top: -30px;
    }
    > * {
      max-width: 600px;
    }
  }
  &__body {
    padding: 80px 30px;
    max-width: 830px;
    margin: 0 auto;
  }
  &__listContainer {
    display: grid;
    grid-template-columns: 1fr 240px;
    column-gap: 40px;
    margin: 60px auto;
  }
  &__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 18px;
    column-gap: 24px;
  }
  &__listItem {
    border: 1px solid rgba(255, 255, 255, 0.2);
    height: 140px;
    border-radius: 8px;
    padding: 18px 20px;
    font-family: CamptonBook;
    font-size: 20px;
    line-height: 1.35;
    color: var(--Neu01);
    transition: all 0.2s ease-in-out;
    &:hover {
      transition: all 0.2s ease-in-out;
      color: var(--Neu10);
      background-color: var(--Neu01);
    }
  }
  @include mq(0, 768px) {
    &__hero {
      padding: 140px 0 60px;
      height: auto;
    }
    &__textBox {
      width: auto;
      em {
        top: 0px;
      }
    }
    &__listContainer,
    &__list {
      grid-template-columns: 1fr;
      margin-bottom: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Productions.vue